import * as CompareFares from './components/CompareFares/CompareFares.css';
import * as Cell from './components/FaresSlider/Content/Cell/Cell.css';
import * as Fare from './components/FaresSlider/Header/Fare/Fare.css';
import * as Footer from './components/FaresSlider/Footer/Footer.css';
import * as ErrorMessage from './components/ErrorMessage/ErrorMessage.css';
import * as Content from './components/FaresSlider/Content/Content.css';
import * as FaresSlider from './components/FaresSlider/FaresSlider.css';
import * as Header from './components/FaresSlider/Header/Header.css';
export default {
    CompareFares,
    FaresSlider,
    Header,
    Cell,
    Fare,
    Footer,
    ErrorMessage,
    Content
};
